import React from 'react';
import ReactDOM from 'react-dom';
import './scss/index.scss';
import Root from './Root';

ReactDOM.render(<Root />, document.getElementById('root'));
